"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Card_1 = __importDefault(require("@material-ui/core/Card"));
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const DocumentForm = (props) => {
    const { documentURL = '', documentName = '', isEditing, onCancel, onItemSubmit } = props;
    const [url, setUrl] = react_1.useState(documentURL);
    const [name, setName] = react_1.useState(documentName);
    const [urlError, setUrlError] = react_1.useState('');
    const [nameError, setNameError] = react_1.useState('');
    const save = () => {
        let isValid = true;
        if (!isEditing && !url.trim()) {
            setUrlError('Document URL is required');
            isValid = false;
        }
        if (!name.trim()) {
            setNameError('Document name is required');
            isValid = false;
        }
        if (!isValid) {
            return;
        }
        if (!isEditing) {
            onItemSubmit(url.trim(), name.trim());
            setUrl('');
            setName('');
            setUrlError('');
            setNameError('');
        }
        else {
            onItemSubmit(name.trim());
        }
    };
    const onKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            save();
        }
    };
    return (react_1.default.createElement(Card_1.default, null,
        react_1.default.createElement(Box_1.default, { p: 2 },
            react_1.default.createElement(Grid_1.default, { container: true },
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                    react_1.default.createElement(Typography_1.default, { variant: "subtitle1" }, isEditing ? 'Edit Document Details' : 'Add Document')),
                !isEditing && (react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                    react_1.default.createElement(Box_1.default, { my: 1 },
                        react_1.default.createElement(TextField_1.default, { id: "document-url-input", fullWidth: true, variant: "filled", label: documentURL ? documentURL : 'Document URL', value: url, onChange: (e) => {
                                setUrl(e.target.value);
                                if (urlError)
                                    setUrlError('');
                            }, onKeyDown: onKeyDown, error: !!urlError, helperText: urlError })))),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                    react_1.default.createElement(Box_1.default, { my: 1 },
                        react_1.default.createElement(TextField_1.default, { id: "document-name-input", fullWidth: true, variant: "filled", label: "Document Name", value: name, onChange: (e) => {
                                setName(e.target.value);
                                if (nameError)
                                    setNameError('');
                            }, onKeyDown: onKeyDown, error: !!nameError, helperText: nameError, inputProps: { maxLength: 512 } }))),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 7 }),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 5 },
                    react_1.default.createElement(Grid_1.default, { container: true },
                        react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 5 }, onCancel && (react_1.default.createElement(Button_1.default, { variant: "contained", color: "secondary", size: "large", onClick: onCancel }, "Cancel"))),
                        react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 7 },
                            react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", size: "large", onClick: () => save() }, isEditing ? 'Save Changes' : 'Add Document'))))))));
};
DocumentForm.propTypes = {
    index: prop_types_1.default.number,
    documentURL: prop_types_1.default.string,
    documentName: prop_types_1.default.string,
    isEditing: prop_types_1.default.bool,
    onCancel: prop_types_1.default.any,
    onItemSubmit: prop_types_1.default.any,
};
exports.default = DocumentForm;
